module.exports = __webpack_public_path__ + "img/logo9.6b2a34b2.png";